import * as React from "react";
const SvgChevronRight = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M9.4 18L8 16.6l4.6-4.6L8 7.4L9.4 6l6 6l-6 6Z" }));
export default SvgChevronRight;
